<li
  class="library-item"
  draggable="true"
  [ngClass]="{ dragged: dragged, 'list-mode': viewMode == 'list' }"
>
  <section>
    <icn-image
      [url]="item.packshotUrl"
      [defaultImage]="'/assets/icons/blocks-icon.svg'"
    ></icn-image>
    <div class="shows-counter">
      <div></div>
      <div class="counter">{{ item.showsCount }}</div>
    </div>
  </section>
  <!-- Hover Layer -->
  <div class="hover-layer" [ngClass]="{ menuActive: menuOpen }">
    <section>
      <settings-button
        *ngIf="currentUser && currentUser.hasEditMAMPermission"
        data-title="EDIT"
        (click)="edit()"
      ></settings-button>
      <remove-button
        *ngIf="currentUser && currentUser.hasEditMAMPermission"
        data-title="DELETE"
        (click)="delete()"
      ></remove-button>
    </section>
  </div>

  <!-- Footer -->
  <footer>
    <span class="item-duration">{{ item.durationAsText }}</span>
    <span>{{ item.name }}</span>

    <a *ngIf="viewMode != 'list'">
      <svg>
        <path
          fill-rule="evenodd"
          d="M6.000,6.999 C5.447,6.999 4.999,6.552 4.999,6.000 C4.999,5.447 5.447,4.999 6.000,4.999 C6.551,4.999 6.999,5.447 6.999,6.000 C6.999,6.552 6.551,6.999 6.000,6.999 ZM6.000,1.999 C5.447,1.999 4.999,1.552 4.999,0.999 C4.999,0.447 5.447,-0.001 6.000,-0.001 C6.551,-0.001 6.999,0.447 6.999,0.999 C6.999,1.552 6.551,1.999 6.000,1.999 ZM0.999,11.999 C0.446,11.999 -0.001,11.552 -0.001,10.999 C-0.001,10.447 0.446,9.999 0.999,9.999 C1.552,9.999 1.999,10.447 1.999,10.999 C1.999,11.552 1.552,11.999 0.999,11.999 ZM0.999,6.999 C0.446,6.999 -0.001,6.552 -0.001,6.000 C-0.001,5.447 0.446,4.999 0.999,4.999 C1.552,4.999 1.999,5.447 1.999,6.000 C1.999,6.552 1.552,6.999 0.999,6.999 ZM0.999,1.999 C0.446,1.999 -0.001,1.552 -0.001,0.999 C-0.001,0.447 0.446,-0.001 0.999,-0.001 C1.552,-0.001 1.999,0.447 1.999,0.999 C1.999,1.552 1.552,1.999 0.999,1.999 ZM6.000,9.999 C6.551,9.999 6.999,10.447 6.999,10.999 C6.999,11.552 6.551,11.999 6.000,11.999 C5.447,11.999 4.999,11.552 4.999,10.999 C4.999,10.447 5.447,9.999 6.000,9.999 Z"
        />
      </svg>
    </a>
  </footer>
</li>
